/*
 * @Author: WUJUN
 * @Date: 2019-10-25 11:15:10
 * @LastEditTime: 2019-10-31 11:36:44
 * @LastEditors: WUJUN
 * @Description:
 */

import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import entity from './modules/entity';
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    // entity中的state不需要存本地
    entity
  },
  plugins: [
    createPersistedState({
      key: 'umi_vuex',
      reducer(val) {
        return {
          app: val.app
        };
      }
    })
  ]
});



// WEBPACK FOOTER //
// src/store/index.js